import { useState } from "react";
import { observer } from "mobx-react";
import { CloseCircle, CloseSquare } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import styles from './shared.module.scss';

const UnsyncModal = observer(({ card, show, setShow, unsync }) => {
    const [loading, setLoading] = useState(false);

    const confirm = async () => {
        setLoading(true);
        await unsync(card._id);
        setLoading(false);
        setShow(false);
    }

    return (
        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                <Box className={styles.deleteIconContainer}>
                    <CloseCircle
                        size="40"
                        variant="Bulk"
                    />
                </Box>
                <Typography fontWeight={600}>Delete Contact</Typography>
                <Typography color='#888888'>Are you sure you want to delete contact?</Typography>
                <Typography >Note: You'll lose access to all contacts cards, and contact will lose access to all your cards.</Typography>

            </DialogContent>
            <DialogActions>
                <LoadingButton loading={!!loading} onClick={() => setShow(false)} variant="contained" color="lightblue">
                    Cancel
                </LoadingButton>
                <LoadingButton loading={!!loading} onClick={confirm} variant="contained" color="error">
                    Unsync
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
});

export default UnsyncModal;
